module.exports = __webpack_public_path__ + "img/board_layout_3.149ffabf.png";